<template>
	<div
		class="g-block-divider-gray-bar g-block-divider-padding"
		:class="{
			'g-block-divider-gray-bar--edit': editable,
			'is-active': editable && active,
			'g-block-divider-gray-bar--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-gray-bar__line"
			:style="{ background: barColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { getTitleThemeColor } from '../../../templates.js';
	import { dividerMixin } from '../shared/dividerMixin.js';

	const DEFAULT_BAR_COLOR = '#e5e7eb';

	export default {
		name: 'GBlockDividerGrayBar',
		mixins: [dividerMixin],
		computed: {
			barColor() {
				if (this.data?.color) {
					return getTitleThemeColor(this.data);
				}
				return DEFAULT_BAR_COLOR;
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-gray-bar {
		.divider-block-edit-shell();
	}

	.g-block-divider-gray-bar__line {
		display: block;
		width: 100%;
		height: 8px;
	}

	.g-block-divider-gray-bar--h5 {
		.g-block-divider-gray-bar__line {
			height: 0.16rem;
		}
	}
</style>
